<template>
    <ad-form v-if="offer"
                :allowed-image-types="allowedImageTypes"
                :max-file-size="maxFileSize"
                :offer="offer"
                :save-handler="handleCreateAd"
                :locale="locale"></ad-form>
</template>

<script>
import AdForm from "../AdForm";
import AdsApi from "../../services/AdsApi";

export default {
    name: 'CreateAd',
    components: {AdForm},
    data() {
        return {
            offer: null
        };
    },
    props: [
        'locale',
        'allowedImageTypes',
        'maxFileSize',
        'productId',
        'csrfToken'
    ],
    created() {
        this.offer = {product_id: this.productId};
    },
    methods: {
        handleCreateAd(offerData) {
            return AdsApi.createAd(offerData, this.locale, this.csrfToken).then((response) => {
                return response.json();
            });
        }
    }
};
</script>

<style scoped>
</style>
